import React, {useState, useRef} from 'react';
import {Flex, Form, Steps} from "antd";
import {useParams} from "react-router-dom";
import {STEP_ITEMS} from "./constants/stepConfig";
import {useMicroQualificationData} from "./hooks/useMicroQualificationData";
import {useMicroQualificationSave} from "./hooks/useMicroQualificationSave";
import {useDocumentPreview} from "./hooks/useDocumentPreview";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";
import FullLoading from "../../../../../components/LoadingComponents/FullLoading";
import HorizontalDivider from "../../../../../components/Divider/HorizontalDivider";
import StepNavigation from "./components/StepNavigation";
import CommentsSection from "./components/CommentsSection";
import Step1GeneralInfo from "./steps/Step1GeneralInfo";
import Step2MainInfo from "./steps/Step2MainInfo";
import Step3Tasks from "./steps/Step3Tasks";
import Step4Competences from "./steps/Step4Competences";
import Step5Results from "./steps/Step5Results";
import Step6Matrix from "./steps/Step6Matrix";
import Step7Disciplines from "./steps/Step7Disciplines";
import Step8Authors from "./steps/Step8Authors";
import classes from "../../Applications/application.module.css";

const MicroQualificationEdit = () => {
    const {id} = useParams();
    const [currentStep, setCurrentStep] = useState(0);
    const connectionsRef = useRef({});

    // Хуки для загрузки данных и управления состоянием
    const {data, isLoading, form} = useMicroQualificationData(id);
    const {save, isLoadingSave} = useMicroQualificationSave(id, form);
    const {sendToCheck} = useDocumentPreview(data?.id, data?.name?.nameEng);

    // Навигация по шагам
    const next = () => setCurrentStep(prev => prev + 1);
    const prev = () => setCurrentStep(prev => prev - 1);
    const onChangeStep = (value) => setCurrentStep(value);

    // Обработчик сохранения
    const handleSave = async () => {
        try {
            if (currentStep === 5) {
                // Для шага 6 (матрица) передаем connections из ref
                await save(currentStep, {connections: connectionsRef.current});
            } else {
                await save(currentStep);
            }
        } catch (error) {
            console.error("Error saving step:", error);
        }
    };

    // Конфигурация компонентов шагов
    const stepComponents = [
        <Step1GeneralInfo form={form} data={data} currentStep={currentStep}/>,
        <Step2MainInfo form={form} data={data} currentStep={currentStep}/>,
        <Step3Tasks currentStep={currentStep}/>,
        <Step4Competences currentStep={currentStep}/>,
        <Step5Results currentStep={currentStep}/>,
        <Step6Matrix data={data} connectionsRef={connectionsRef}/>,
        <Step7Disciplines data={data}/>,
        <Step8Authors/>,
    ];

    if (isLoading) {
        return <FullLoading/>;
    }

    return (
        <Flex style={{width: "100%", position: "relative", minWidth: 800}} gap={20} vertical>
            <BlockLoading isLoading={isLoadingSave}/>

            <Steps
                onChange={onChangeStep}
                current={currentStep}
                items={STEP_ITEMS}
                labelPlacement={"vertical"}
                size={"small"}
            />

            <HorizontalDivider style={{backgroundColor: "#e5e5e5"}}/>

            <Form form={form} className={classes.form}>
                {stepComponents[currentStep]}
            </Form>

            <StepNavigation
                currentStep={currentStep}
                totalSteps={stepComponents.length}
                onPrev={prev}
                onNext={next}
                onSave={handleSave}
                onSendToCheck={sendToCheck}
                isLoading={isLoadingSave}
            />

            <CommentsSection comments={data?.comments}/>
        </Flex>
    );
};

export default MicroQualificationEdit;
